import React from 'react';
import { BadgeCheckIcon, UserCogIcon } from 'lucide-react';
import { OfficerSelect } from './OfficerSelect';
import type { LoanOfficer, TierPlan } from '../types/commission';
import { statusLabel } from '../utils/commission';
import { formatBps, formatPercent } from '../utils/format';
interface OfficerBarProps {
  officer: LoanOfficer;
  plan: TierPlan;
  onOfficerChange: (officerId: string) => void;
}
export function OfficerBar({
  officer,
  plan,
  onOfficerChange
}: OfficerBarProps) {
  const isCustom = plan.status === 'custom';
  return <div className="flex flex-col gap-4 rounded-xl border border-slate-200 bg-white px-5 py-4 shadow-sm lg:flex-row lg:items-center lg:justify-between" data-id="element-83" data-mp="w6prdx0u74kr">
      <div className="flex items-center gap-4" data-id="element-84" data-mp="m8iky846c4x0">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-50 text-sm font-semibold text-brand-700" data-id="element-85" data-mp="m78lbehoaoo9">
          {officer.initials}
        </span>
        <div data-id="element-86" data-mp="3702dbedtkgjr">
          <p className="text-lg font-semibold text-slate-900" data-id="element-87" data-mp="370luutzk52x9">{officer.name}</p>
          <div className="mt-1 flex flex-wrap items-center gap-2 text-xs" data-id="element-88" data-mp="ljdl1wxo97ak">
            <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 font-semibold ${isCustom ? 'bg-amber-100 text-amber-800' : 'bg-slate-100 text-slate-700'}`} data-id="element-89" data-mp="gkaqj6fbijgu">
              {isCustom ? <UserCogIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-90" data-mp="14gom9n2v6asn" /> : <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-91" data-mp="zj544c31pdvf" />}
              {statusLabel(officer.status)}
            </span>
            <span className="text-slate-500" data-id="element-92" data-mp="1e9ch4caaa4oq">{officer.branch}</span>
            <span className="text-slate-300" aria-hidden="true" data-id="element-93" data-mp="199hqm9uf7h47">
              ·
            </span>
            <span className="text-slate-500" data-id="element-94" data-mp="1n8pn2uz78b4p">{plan.name}</span>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-4 sm:flex-row sm:items-end" data-id="element-95" data-mp="1iaftgot4hil7">
        <div className="rounded-lg bg-slate-50 px-3 py-2 text-xs text-slate-600" data-id="element-96" data-mp="fw884v2nkcnz">
          <p className="font-semibold text-slate-700" data-id="element-97" data-mp="ku9y7zyhxc8y">
            {plan.tiers.length} tiers · {formatBps(plan.tiers[0].basisPoints)} –{' '}
            {formatBps(plan.tiers[plan.tiers.length - 1].basisPoints)} ·{' '}
            {formatPercent(plan.tiers[0].overageSplit)} –{' '}
            {formatPercent(plan.tiers[plan.tiers.length - 1].overageSplit)} overage
          </p>
          <p className="mt-0.5 max-w-sm" data-id="element-98" data-mp="yoau8ly2cl5m">{plan.description}</p>
        </div>
        <div className="w-full sm:w-64" data-id="element-99" data-mp="13j6m9m3av8iq">
          <OfficerSelect value={officer.id} onChange={onOfficerChange} data-id="element-100" data-mp="18kdutnd9obqg" />
        </div>
      </div>
    </div>;
}